module.exports = __webpack_public_path__ + "static/media/html.f0361c5e.svg";